export const isPusherConnecting = state => state.pusher.get('connecting');
export const isPusherConnected = state => state.pusher.get('connected');
export const didJoinAllNotificationChannels = state =>
  state.pusher.get('joinedAllNotificationChannels');
